
const state = {
    me: null,
    realtimeStatisticsData: null,
    realtimeStatisticsIsShow: false,
    realtimeStatisticsIsLoading: false,
    realtimeStatisticsRefresh: 0,
    realtimeStatisticsConfig: {
        data_date: undefined,
		data_date_end: undefined
    },
    test1: 1024,
}

const mutations = {

	SET_ME(state,value){
		state.me = value
	},
	SET_MOBILE(state,value){
		state.mobile = value
	},
	SET_REALTIME_STATISTICS_DATA(state,value){
        state.realtimeStatisticsData = value
    },
    SET_REALTIME_STATISTICS_IS_SHOW(state, value) {
        state.realtimeStatisticsIsShow = value
    },
    SET_REALTIME_STATISTICS_IS_LOADING(state, value) {
        state.realtimeStatisticsIsLoading = value
    },
    SET_REALTIME_STATISTICS_REFRESH(state, value) {
        state.realtimeStatisticsRefresh = value
    },
    SET_REALTIME_STATISTICS_CONFIG(state, keyAndValue) {
        console.log('state:SET_REALTIME_STATISTICS_CONFIG:', keyAndValue[0], state.realtimeStatisticsConfig[keyAndValue[0]], ' => ', keyAndValue[1])
        state.realtimeStatisticsConfig[keyAndValue[0]] = keyAndValue[1];
		state.realtimeStatisticsConfig[keyAndValue[2]] = keyAndValue[3]
    }
}

export default {
	state,
	mutations,
    actions:mutations,
    modules:{},
}
